import {
  Image,
  StyleSheet,
  Text,
  TouchableOpacity,
  TouchableOpacityProps,
} from "react-native";
import React, { forwardRef } from "react";
import { AppFontStyle } from "../styles/AppFontStyle";
import { s } from "react-native-size-matters";
import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";
import { AppColors } from "../utility/AppColors";
interface CommonSearchButtonProps extends TouchableOpacityProps {
  title?: string;
  onTap?: () => void;
  textStyle?: object;
  buttonStyle?: object;
  disabled?: any;
  disabledCustomStyle?: any;
  image?: boolean;
  imageStyle?: any;
  imageUrl?: string;
  fontStyle?: any;
  imagePosition?: string;
}

export const CommonButton = (props: any) => {
  const {
    title = "",
    onTap = () => {},
    buttonStyle,
    textStyle,
    disabled,
    disabledCustomStyle,
    image = false,
    imageStyle,
    imageUrl = "",
    fontStyle = AppFontStyle.BOLD_ANYBODY_14,
    imagePosition = "pre",
  } = props;

  return (
    <TouchableOpacity
      activeOpacity={0.5}
      style={[
        styles.mainStyle,
        buttonStyle,
        disabled
          ? disabledCustomStyle
            ? disabledCustomStyle
            : styles.disabledButtonStyle
          : {},
        image ? { flexDirection: "row", alignItems: "center", gap: 5 } : {},
      ]}
      onPress={onTap}
      disabled={disabled}
    >
      {image && imagePosition === "pre" && (
        <Image
          source={imageUrl}
          style={[
            imageStyle,
            {
              resizeMode: "contain",
            },
          ]}
        />
      )}

      <Text style={[fontStyle, { alignSelf: "center" }, textStyle]}>
        {title}
      </Text>
      {image && imagePosition === "post" && (
        <Image
          source={imageUrl}
          style={[
            imageStyle,
            {
              resizeMode: "contain",
            },
          ]}
        />
      )}
    </TouchableOpacity>
  );
};

export const CommonSearchButton = forwardRef<
  TouchableOpacity,
  CommonSearchButtonProps
>((props, ref) => {
  const {
    title = "",
    onTap = () => {},
    buttonStyle,
    textStyle,
    ...rest
  } = props;

  return (
    <TouchableOpacity
      ref={ref} // Attach ref here
      activeOpacity={0.5}
      style={[styles.mainStyle, buttonStyle]}
      onPress={onTap}
    >
      <Text
        style={[
          AppFontStyle.BOLD_ANYBODY_14,
          { color: AppColors.white, alignSelf: "center" },
          textStyle,
        ]}
      >
        {title}
      </Text>
    </TouchableOpacity>
  );
});
export const ImageButton = (props: any) => {
  const { image, onTap = () => {}, buttonStyle, imageStyle } = props;
  return (
    <TouchableOpacity
      activeOpacity={0.5}
      style={[styles.imgBtnStyle, buttonStyle]}
      onPress={onTap}
    >
      <Image
        source={image}
        style={[{ height: 20, width: 18, resizeMode: "contain" }, imageStyle]}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  mainStyle: {
    paddingHorizontal: s(14),
    paddingVertical: s(14),
    backgroundColor: AppColors.themeColor_0A89AD,
    borderRadius: s(50),
    justifyContent: "center",
    alignItems: "center",
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.3,
    shadowRadius: s(10),
    elevation: s(10),
  },
  disabledButtonStyle: {
    backgroundColor: AppColors.grayColor_393939, // Disabled state background color
    opacity: 0.5, // Reduced opacity for disabled button
  },
  imgBtnStyle: {
    flex: 1,
    height: 40,
    width: 40,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: AppColors.appViolentColor_6D08C3,
    borderRadius: 10,
  },
});
